export const en = {
    seconds: 'sec'
};
